type TextResolverConfigType = {
  alwaysUseKeys: boolean;
  useKeyWhenTextNotFound: boolean;
  warnNotFoundKeys: boolean;
  useKeyWhenTranslationNotFound: boolean;
  warnWhenTranslationNotFound: boolean;
};

type StoredTextResolverValues = Partial<
  Pick<TextResolverConfigType, 'alwaysUseKeys' | 'useKeyWhenTextNotFound' | 'warnNotFoundKeys'>
>;

const getConfigFromSessionStorage = (): TextResolverConfigType => {
  const storedValues: StoredTextResolverValues = JSON.parse(
    sessionStorage.getItem('debugTextResolver') ?? 'null',
  );
  const alwaysUseKeys = storedValues?.alwaysUseKeys ?? false;
  const useKeyWhenTextNotFound = storedValues?.useKeyWhenTextNotFound ?? false;
  const warnNotFoundKeys = storedValues?.warnNotFoundKeys ?? false;
  const useKeyWhenTranslationNotFound = useKeyWhenTextNotFound;
  const warnWhenTranslationNotFound = warnNotFoundKeys;
  return {
    alwaysUseKeys,
    useKeyWhenTextNotFound,
    warnNotFoundKeys,
    useKeyWhenTranslationNotFound,
    warnWhenTranslationNotFound,
  };
};

export const generateTextResolverConfig = (debugEnabled: boolean) => ({
  ...(debugEnabled && getConfigFromSessionStorage()),
});
